import {BitData} from "../types/BitData";
import {StagingTitelineAppBit} from "../types/StagingTitelineAppBit";
import { getApiUrl } from '../config/api';

export const fetchBitsByPid = async (pid: number, aid: number = -1): Promise<BitData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineBits/GetBitsByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No bits found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching bits for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppBit[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((bit) => bit.DataSource === aid.toString());
        }

        return backendData.map((bit) => ({
            key: bit.BitId,
            bit_id: bit.BitId,
            pid: bit.Pid,
            hole_id: bit.HoleID,
            bit_or_reamer: bit.BitOrReamer,
            serial_no: bit.SerialNo,
            size: bit.Size,
            type: bit.Type,
            depth_from: bit.DepthFrom,
            depth_to: bit.DepthTo,
            total_metres: bit.TotalMetres,
        }));
    } catch (error) {
        console.error("Error in fetchCasingByPid API call:", error);
        return [];
    }
};

export const addBitRow = async (bitRow: BitData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineBits/AddBits');

    const cloudPayload = [
        {
            Pid: bitRow.pid ?? -1,
            BitOrReamer: bitRow.bit_or_reamer,
            SerialNo: bitRow.serial_no,
            Size: bitRow.size,
            Type: bitRow.type,
            HoleID: bitRow.hole_id,
            DepthFrom: bitRow.depth_from,
            DepthTo: bitRow.depth_to,
            TotalMetres: bitRow.total_metres,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Bit row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add bit row to cloud:",
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in addBitRow API call:", error);
        return false;
    }
};

export const updateBitRow = async (bit_id: number, updatedRow: BitData) => {
    const apiUrl = getApiUrl(`/api/TitelineBits/UpdateBitByBitId/${bit_id}`);

    const cloudPayload = {
        BitOrReamer: updatedRow.bit_or_reamer,
        SerialNo: updatedRow.serial_no,
        Size: updatedRow.size,
        Type: updatedRow.type,
        HoleID: updatedRow.hole_id,
        DepthFrom: updatedRow.depth_from,
        DepthTo: updatedRow.depth_to,
        TotalMetres: updatedRow.total_metres,
    };

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Bit row with BitId ${bit_id} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update bit row with BitId ${bit_id}:`,
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in updateBitRow API call:", error);
        return false;
    }
};

export const deleteBitByBitId = async (bit_id: number) => {
    const apiUrl = getApiUrl(`/api/TitelineBits/DeleteBitByBitId/${bit_id}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteBitByBitId API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete bit row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteBitByBitId API call:", error);
        return false;
    }
};


